import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import { settingSecondFactorId } from "../../../utilities/API/supertokenServices"
import { toast } from "react-toastify"

export const secondFactorIdService = createAsyncThunk(
    'fetchPreAuthFAF', settingSecondFactorId
)

const initialState = {
    loader: false
}

const secondFactorIdSlice = createSlice({
    name: 'preAuth',
    initialState,
    reducers: {
        resetSecondFactorId: (state) => {
            state.loader = false
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(secondFactorIdService.pending, (state, action) => {
                state.loader = true
            })
            .addCase(secondFactorIdService.fulfilled, (state, action) => {
                state.loader = false
            })
            .addCase(secondFactorIdService.rejected, (state, action) => {
                toast.error(action.error.message)
                state.loader = false
            })
    }
})

export const { resetSecondFactorId } = secondFactorIdSlice.actions

export default secondFactorIdSlice.reducer